import { render, staticRenderFns } from "./indian-dentists.vue?vue&type=template&id=64d97395&scoped=true&"
import script from "./indian-dentists.vue?vue&type=script&lang=js&"
export * from "./indian-dentists.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d97395",
  null
  
)

export default component.exports